const initialSubscriptionState = {
  user: {
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    isProfessional: false,
    isProvider: false,
    address: "",
    postalCode: "",
    city: "",
    countryCode: "fr",
  },
  company: {
    logoPreviewUrl: "",
    name: "",
    identifier: "",
    description: "",
    presentationVideoBase64: "",
    modeSelectionVideo:null,
    address: "",
    postalCode: "",
    city: "",
    countryCode: "",
    isAddressSameAsUser: true,
  },
  
};

const subscriptionReducer = (state = initialSubscriptionState, action) => {
  switch (action.type) {
    case "SET_USER_FIELD":
      return {
        ...state,
        user: {
          ...state.user,
          [action.field]: action.value,
        },
      };
    case "SET_COMPANY_FIELD":
      return {
        ...state,
        company: {
          ...state.company,
          [action.field]: action.value,
        },
      };
    
    case "RESET_SUBSCRIPTION":
      return initialSubscriptionState;
    default:
      return state;
  }
};
export default subscriptionReducer
